module.exports = __webpack_public_path__ + "img/juan.cbf0e86c.png";